import React, { useState } from 'react';
import { Col, Nav, NavItem, Row, Tab } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ProtocolPractitionersContainer } from '../Practitioners/Practitioners.jsx';
import ProtocolScopedGroupsContainer from './GroupsContainer';
import Card from '../../../components/Cards/Card';

const TeamContainer = ({ protocolId }) => {
    const { t } = useTranslation();
    const [selectedSubTab, setSelectedSubTab] = useState('personal');

    return (
        <Card
            content={
                <Tab.Container id="team-subtabs-protocol" activeKey={selectedSubTab} onSelect={setSelectedSubTab}>
                    <Row className="clearfix">
                        <Col sm={12}>
                            <Nav bsStyle="tabs">
                                <NavItem eventKey="personal">
                                    {t('clinicalTrials.team.personal')}
                                </NavItem>
                                <NavItem eventKey="group">
                                    {t('clinicalTrials.team.group')}
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col sm={12}>
                            <Tab.Content animation mountOnEnter={true}>
                                <Tab.Pane eventKey="personal">
                                    <ProtocolPractitionersContainer protocolId={protocolId} />
                                </Tab.Pane>
                                <Tab.Pane eventKey="group">
                                    <ProtocolScopedGroupsContainer protocolId={protocolId} />
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            }
        />
    );
};

export default TeamContainer;
